import { render, staticRenderFns } from "./DailyMilkRecording.vue?vue&type=template&id=cc5ac9e6&scoped=true&"
import script from "./DailyMilkRecording.vue?vue&type=script&lang=js&"
export * from "./DailyMilkRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5ac9e6",
  null
  
)

export default component.exports